/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI2IiBjeT0iNi42NjQwNiIgcj0iNS4xNzM4MyIgZmlsbD0iI0ZBRkFGQSIgc3Ryb2tlPSIjNDJBM0U1Ii8+PHBhdGggZD0iTTUuNjc1NjIgOS42NzEzOEg2LjU0NjAyVjcuMDYwMThIOC45NjUyMlY2LjI5MjE4SDYuNTQ2MDJWMy42ODA5OEg1LjY3NTYyVjYuMjkyMThIMy4yNTY0MlY3LjA2MDE4SDUuNjc1NjJWOS42NzEzOFoiIGZpbGw9IiM0MkEzRTUiLz48L3N2Zz4=";